import React, { useState, useCallback } from 'react';
import Calendar from 'rc-calendar';
import { last } from 'lodash';

export default ({ allowedPanels, defaultMode, onSelect, ...props }) => {
  const [mode, setMode] = useState(last(allowedPanels));

  const handlePanelChange = useCallback(
    (value, mode) => {
      if (allowedPanels.includes(mode)) {
        setMode(mode);
      } else {
        onSelect(value);
      }
    },
    [allowedPanels, onSelect]
  );

  return (
    <Calendar {...props} onPanelChange={handlePanelChange} mode={mode} showDateInput={false} />
  );
};
